var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"iconfont",class:`icon-${_vm.name}`,style:({fontSize: `${_vm.fontSize}rem`, color: _vm.color, marginLeft: `${_vm.marginLeft}rem`, marginRight: `${_vm.marginRight}rem`})})
}
var staticRenderFns = []

export { render, staticRenderFns }